jQuery(document).ready(() => {
  require('./util');
  require("./cookie-consent");
  require('./woocommerce/single-product');
  require('./woocommerce/cart');
  require('./woocommerce/products/index.js');
  require('./components');
  require('./post-types');
  require('./custom');  
})